import { createContext, useState } from 'react'
import { WithChildren } from '_metronic/helpers'

interface IContext {
  isOpenMaintenanceModal: boolean
  toggleMaintenanceModal: (isOpen: boolean) => void
  isView: boolean
  setIsView: (isView: boolean) => void
}

export const MaintenanceListViewContext = createContext<IContext>({
  isOpenMaintenanceModal: false,
  toggleMaintenanceModal: () => {},
  isView: false,
  setIsView: () => {},
})

export const MaintenanceListViewContextProvider: React.FC<WithChildren> = ({ children }) => {
  const [isOpenMaintenanceModal, setIsOpenMaintenanceModal] = useState(false)
  const [isView, setIsView] = useState(false)

  const toggleMaintenanceModal = (isOpen: boolean) => {
    setIsOpenMaintenanceModal(isOpen)
  }

  return (
    <MaintenanceListViewContext.Provider
      value={{
        isOpenMaintenanceModal,
        isView,
        toggleMaintenanceModal,
        setIsView,
      }}>
      {children}
    </MaintenanceListViewContext.Provider>
  )
}
